import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { deleteZoneType, loadZonesType } from '../../../../store/Actions/ActionZoneType';
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom';
import ReactLoading from "react-loading";
import ZoneTypeSkeleron from '../../../../components/general/general-component/skeleton-components/ZoneTypeSkeleron';

function ShowZoneType({ langLocal, translate, zone_type_arr }) {
    const [tempArr, setTempArr] = useState(zone_type_arr)
    const { zoneType,loadingZoneType } = useSelectorCustom()
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    const [loadDel, setloadDel] = useState(false)
    const [zoneTypeArr, setZoneTypeArr] = useState([])
    const [tempId, setTempId] = useState(null)
    const { dispatch } = AbstructVar();
    useEffect(() => {
        dispatch(loadZonesType())
    }, []);
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...zoneTypeArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setZoneTypeArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, zoneTypeArr]);
    useEffect(() => {
        if (zoneType?.length >= 0) {
            setZoneTypeArr(zoneType)
        }
    }, [zoneType]);
    const handleDelete = (id) => {
        dispatch(deleteZoneType(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    return (
        <div>
            {
                !loadingZoneType ?(
                zoneTypeArr?.map((type) => {
                    return (
                        <div className='div_zont_type' >
                            <p className={` one_zone_type ${langLocal === 'ar' ? "margin_left_15" : "margin_right_15"} `} >{type?.name}</p>
                            <p className={` one_zone_type ${langLocal === 'ar' ? "margin_left_15" : "margin_right_15"} `}>{type?.symbol}</p>
                            <div className='plus_zone_typ' style={{ marginTop: '0px' }}
                                onClick={() => { setTempId(type?.id); handleDelete(type?.id) }}
                            >
                                {
                                    loadDel && type?.id === tempId ? <ReactLoading
                                        type="spin"
                                        color="black"
                                        height={"40%"}
                                        width={"40%"}
                                    /> : <i className='fa fa-trash' ></i>
                                }

                            </div>
                        </div>
                    )
                })): <ZoneTypeSkeleron langLocal={langLocal} />
            }

        </div>
    )
}

export default ShowZoneType